var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-dropdown"},_vm._l((_vm.links),function(link,index){return _c('a',{key:("single-dropdown-link-" + index),attrs:{"href":link.url,"target":"_blank"}},[_vm._v("\n        "+_vm._s(link.title)+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }